import script from "./TicketUsedBy.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketUsedBy.vue?vue&type=script&setup=true&lang=js"

import "./TicketUsedBy.vue?vue&type=style&index=0&id=48000453&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48000453"]])

export default __exports__